<template>
  <div class="row">
    <div class="col_12">
      <div class="card">
        <div class="card_heading">Chat</div>
        <div class="card_body chat_box_wrap">
          <nav class="tabs mb_10">
            <ul class="">
              <li
                href="#tab1"
                :class="{ active: isFilterTabActive === 'all' }"
                @click="filterChatStatusTab('all', (isFilterTabActive = 'all'))"
              >
                All
              </li>
              <li
                href="#tab2"
                :class="{ active: isFilterTabActive === 'ticket' }"
                @click="
                  filterChatStatusTab(
                    'is_ticket',
                    (isFilterTabActive = 'ticket')
                  )
                "
              >
                Ticket
              </li>
              <li
                href="#tab3"
                :class="{ active: isFilterTabActive === 'closed' }"
                @click="
                  filterChatStatusTab('closed', (isFilterTabActive = 'closed'))
                "
              >
                Closed
              </li>
              <!--                  <li href="#tab3" :class="{active: isFilterTabActive === 'cancel'}" @click="filterChatStatusTab('cancel', isFilterTabActive = 'cancel')">Cancel</li>-->
            </ul>
          </nav>
          <div class="chat_box">
            <div class="chat_box_left">
              <div class="search_box_wrap">
                <div class="search_box">
                  <input
                    type="text"
                    class="form_global"
                    placeholder="Search by email, name..."
                    v-model="queryParams.search_key"
                    @keyup="filterItems"
                  />
                  <span v-if="queryParams.search_key" @click="clearSearch()"
                    ><i class="far fa-times-circle"></i
                  ></span>
                </div>
              </div>
              <div class="user_list">
                <ul>
                  <li
                    v-for="(chat, i) in filteredChats"
                    :key="'sdf' + i"
                    @click="selectCurrentCustomer(i)"
                  >
                    <div
                      class="user_list_inner"
                      :class="{
                        selected_customer: chat.id === currentCustomer.id,
                      }"
                    >
                      <div
                        class="unseen_notification"
                        v-if="chat.status == 'open' && chat.unread_message"
                      >
                        {{ chat.unread_message }}
                      </div>
                      <div class="img_wrap">
                        <div class="img">
                          <img
                            :src="
                              chat.lastMessage?.customer
                                ? chat.lastMessage?.customer?.profile_image
                                : `${baseUrl}assets/media/images/profile.png`
                            "
                            alt=""
                          />
                        </div>
                      </div>
                      <div class="text">
                        <div class="time" v-if="chat.lastMessage">
                          {{ chat.lastMessage.created_at }}
                        </div>
                        <h3 style="text-transform: capitalize">
                          {{ chat.customer.name }}
                        </h3>
                        <div class="chat_text">
                          <p v-if="chat.lastMessage" style="opacity: 0.5">
                            {{
                              chat.lastMessage.message === null &&
                              chat.lastMessage.link != null
                                ? 'Image'
                                : chat.lastMessage.message
                            }}
                          </p>
                          <p v-else style="opacity: 0.5">No messages yet!</p>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="chat_box_right">
              <div class="user_list_inner">
                <div class="user_list_inner_content d_flex_btwn width_full">
                  <div class="d_flex_start">
                    <div class="img_wrap">
                      <div class="img">
                        <img
                          :src="
                            currentCustomer?.customer
                              ? currentCustomer?.customer?.profile_image
                              : `${baseUrl}assets/media/images/profile.png`
                          "
                          alt=""
                        />
                      </div>
                    </div>
                    <div class="text">
                      <h3 class="font_16p">
                        {{ currentCustomer?.customer.name }}
                      </h3>
                      <div class="chat_text">
                        <a
                          href="javascript:void(0)"
                          class="mr_10 td_underline"
                          @click="openCreateChatTicket"
                          >Create Ticket</a
                        >
                        <a
                          v-if="currentCustomer?.customer?.tickets?.length > 0"
                          href="javascript:void(0)"
                          class="mr_10 td_underline"
                          @click="isShowCloseTicketModal = true"
                        >
                          Close Ticket
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="d_flex_end">
                    <span v-show="currentCustomer" class="font_16p">
                      {{ currentCustomer?.status }}</span>
                  </div>
                </div>
                <!--                            <div class="img_wrap">
                            <div class="img">
                              <img :src="currentCustomer && currentCustomer.lastMessage && currentCustomer.lastMessage.customer ? currentCustomer.lastMessage.customer.profile_image : `${baseUrl}assets/media/images/profile.png`" alt="" />
                            </div>
                          </div>-->
                <!--                            <div class="text">
                            <h3 v-if="currentCustomer">{{ currentCustomer.name }}</h3>
                            <h3 v-else>Customer Not Selected yet!</h3>
                            <div v-if="currentCustomer" class="chat_text">
                              <p>{{ currentCustomer.email }}</p>
                            </div>
                            <div v-else class="chat_text">
                              <p>Customer Not Selected yet!</p>
                            </div>
                          </div>-->
              </div>
              <div class="left-nav-bottom-wrap" id="nav_bottom_wrap">
                <div class="right_chat_box" id="scrollableDiv">
                  <div class="chat_box_inner">
                    <ul
                      v-if="currentCustomer && currentCustomer.messages.length"
                    >
                      <template
                        v-for="(message, index) in currentCustomer.messages"
                        :key="'message_' + index"
                      >
                        <li :class="[{ left: message.type != 'admin' }]">
                          <div class="chat_box_inline">
                            <div class="right_arrow">
                              <div class="img">
                                <img
                                  v-if="
                                    message.type == 'admin' && message.admin_id
                                  "
                                  :src="
                                    message.admin
                                      ? message.admin.profile_image
                                      : `${baseUrl}assets/media/images/profile.png`
                                  "
                                  alt=""
                                />
                                <img
                                  v-else-if="
                                    message.type == 'admin' && message.user_id
                                  "
                                  :src="
                                    message.user
                                      ? message.user.profile_image
                                      : `${baseUrl}assets/media/images/profile.png`
                                  "
                                  alt=""
                                />
                                <img
                                  v-else
                                  :src="
                                    message.customer
                                      ? message.customer.profile_image
                                      : `${baseUrl}assets/media/images/profile.png`
                                  "
                                  alt=""
                                />
                              </div>
                            </div>
                            <div class="main_chat_text">
                              <template v-if="message.type == 'admin'">
                                <p v-if="message.admin">
                                  {{ message.admin.name }}
                                </p>
                                <p v-if="message.user">
                                  {{ message.user.name }}
                                </p>
                              </template>
                              <span :class="[{ opacity_5: !message.id }]">
                                <a
                                  v-if="message.link"
                                  :href="message.link"
                                  target="_blank"
                                  class="d_block"
                                >
                                  <template v-if="getFileExtension(message.link) === 'pdf'">
                                    <embed :src="message.link" width="150">
                                    <div><a :href="message.link" target="_blank">Open PDF</a></div>
                                  </template>
                                  <img
                                      v-else
                                    :src="message.link"
                                    alt=""
                                    class=""
                                    style="max-width: 200px"
                                    @load="scrollDown"
                                  />
                                </a>
                                {{ message.message }}
                              </span>
                              <div class="time">
                                {{ message.created_at }}
                                <div
                                  class="blinking_dot"
                                  v-if="message.type === 'admin' && !message.id"
                                >
                                  <div class="loader">
                                    <span class="loader__dot">.</span
                                    ><span class="loader__dot">.</span
                                    ><span class="loader__dot">.</span>
                                  </div>
                                </div>
                                <div
                                  v-if="message.type === 'admin'"
                                  :class="[
                                    'read_status',
                                    { color_green: message.read },
                                    { opacity_5: !message.read },
                                  ]"
                                  style="float: right; margin-left: 6px"
                                >
                                  <i class="fas fa-check"></i>
                                </div>
                                <span
                                  v-if="message.type === 'admin' && message.id"
                                  @click="removeMessage(index, message)"
                                  style="float: right; margin-left: 10px"
                                >
                                  <i class="fas fa-trash open_msg_menu"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </li>
                      </template>
                    </ul>
                    <div class="attached_image" v-if="temFile">
                      <template v-if="fileType === 'application/pdf'">
                        <embed :src="temFile" width="150">
                      </template>
                      <img v-else :src="temFile" width="80" alt="" />
                      <span @click="removeImage()"
                        >
                        <i class="far fa-window-close ml_10" style="color: red; position: absolute;"></i>
                      </span>
                    </div>
                    <!----><!---->
                    <div
                      v-if="
                        currentCustomer && currentCustomer.status === 'closed'
                      "
                    >
                      <div class="chat_input_box chat_close_message">
                        <p>
                          Chat session has been closed by
                          {{ currentCustomer?.customer?.name }}
                        </p>
                      </div>
                    </div>
                    <div
                      v-if="
                        currentCustomer && currentCustomer.status === 'open'
                      "
                      class="chat_input_box"
                    >
                      <span
                        class="attatch_file_btn txt_black"
                        @click="openFileModal"
                      >
                        <i class="fas fa-paperclip"></i>
                      </span>
                      <input
                        type="file"
                        ref="fileInput"
                        style="display: none"
                        accept="image/*,application/pdf"
                        @change="onFileChange($event)"
                      />
                      <input
                        class="message_input"
                        type="text"
                        v-model="form.message"
                        @keyup.enter="sendMessage"
                        @paste="handlePaste"
                        placeholder="Type your message..."
                      />
                      <button class="cursor_pointer" @click="sendMessage">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="stroke-1.5 w-4 h-4"
                        >
                          <line x1="22" y1="2" x2="11" y2="13"></line>
                          <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--  start right sidebar ticket form-->
    <div class="right_menu">
      <h2>
        <span>Ticket</span>
        <div
          class="close_right_menu cursor_pointer"
          @click="closeCreateChatTicket"
        >
          <span
            ><svg
              aria-hidden="true"
              focusable="false"
              role="presentation"
              class="icon icon-close"
              viewBox="0 0 64 64"
            >
              <path d="M19 17.61l27.12 27.13m0-27.12L19 44.74"></path></svg
          ></span>
        </div>
      </h2>
      <div class="right_menu_content">
        <div class="row">
          <div class="col_6">
            <div :class="['form_row', { has_error: errorFor('group_id') }]">
              <label class="required">Group</label>
              <Multiselect
                v-model="selectedGroup"
                :options="groups"
                :multiple="false"
                :close-on-select="true"
                placeholder="Select a group"
                label="name"
                track-by="id"
                :optionHeight="20"
                @Select="onGroupSelect"
                @remove="onGroupRemove"
              />
              <v-errors :errors="errorFor('group_id')"></v-errors>
            </div>
          </div>
          <div class="col_6">
            <div :class="['form_row', { has_error: errorFor('user_id') }]">
              <label class="required">User</label>
              <Multiselect
                v-model="selectedUser"
                :options="users"
                :multiple="true"
                :optionHeight="20"
                :close-on-select="true"
                placeholder="Select a user"
                label="name"
                track-by="id"
                @remove="onUserRemove"
              />
              <v-errors :errors="errorFor('user_id')"></v-errors>
            </div>
          </div>
          <div class="col_6">
            <div :class="['form_row', { has_error: errorFor('status') }]">
              <label class="required">Status</label>
              <Multiselect
                v-model="selectedStatus"
                :options="statuses"
                :multiple="false"
                :close-on-select="true"
                :optionHeight="20"
                placeholder="Select a status"
                label="name"
                track-by="label"
                @Select="onStatusSelect"
                @remove="onStatusRemove"
              />
              <v-errors :errors="errorFor('status')"></v-errors>
            </div>
          </div>
          <div class="col_6">
            <div :class="['form_row', { has_error: errorFor('priority') }]">
              <label class="required">Priority</label>
              <Multiselect
                v-model="selectedPriority"
                :options="priorities"
                :multiple="false"
                :optionHeight="20"
                :close-on-select="true"
                placeholder="Select a priority"
                label="name"
                track-by="label"
                @Select="onPrioritySelect"
                @remove="onPriorityRemove"
              />
              <v-errors :errors="errorFor('priority')"></v-errors>
            </div>
          </div>
          <div class="col_12">
            <div :class="['form_row', { has_error: errorFor('subject') }]">
              <label class="required">Subject</label>
              <div class="form_inline">
                <input
                  type="text"
                  class="form_global"
                  v-model="ticket.subject"
                />
                <v-errors :errors="errorFor('subject')"></v-errors>
              </div>
            </div>
          </div>
          <div class="col_12">
            <div class="row">
              <div class="col_10">
                <div
                  :class="['form_row', { has_error: errorFor('contact_id') }]"
                >
                  <label class="required">Contact Email</label>
                  <Multiselect
                    v-model="selectedContact"
                    :options="contacts"
                    :multiple="false"
                    :close-on-select="true"
                    placeholder="Select a contact"
                    label="name"
                    :optionHeight="20"
                    track-by="id"
                    :custom-label="nameWithEmail"
                    @Select="onContactSelect"
                    @remove="onContactRemove"
                  />
                  <v-errors :errors="errorFor('contact_id')"></v-errors>
                </div>
              </div>
              <div class="col_2 m-auto">
                <button class="btn btn_primary" @click="openModal">
                  Add New
                </button>
              </div>
            </div>
          </div>
          <div class="col_6">
            <div
              :class="['form_row', { has_error: errorFor('customer_name') }]"
            >
              <label>Contact name</label>
              <div class="form_inline">
                <input
                  type="text"
                  class="form_global"
                  v-model="ticket.customer_name"
                />
                <v-errors :errors="errorFor('customer_name')"></v-errors>
              </div>
            </div>
          </div>
          <div class="col_6">
            <div
              :class="['form_row', { has_error: errorFor('customer_phone') }]"
            >
              <label>Contact phone</label>
              <div class="form_inline">
                <input
                  type="text"
                  class="form_global"
                  v-model="ticket.customer_phone"
                />
                <v-errors :errors="errorFor('customer_phone')"></v-errors>
              </div>
            </div>
          </div>
          <div class="col_6" v-if="!selectedContact?.company_id">
            <div
              :class="['form_row', { has_error: errorFor('new_company_id') }]"
            >
              <label>Company</label>
              <div class="form_inline">
                <Multiselect
                  v-model="selectedCompany"
                  :options="companies"
                  :multiple="false"
                  :close-on-select="true"
                  placeholder="Select a company"
                  label="company_name"
                  :optionHeight="20"
                  track-by="id"
                />
                <v-errors :errors="errorFor('new_company_id')"></v-errors>
              </div>
            </div>
          </div>
          <div class="col_6" v-else>
            <div :class="['form_row']">
              <label>Company</label>
              <div class="form_inline">
                <input
                  type="text"
                  :value="selectedContact?.company?.company_name"
                  class="form_global"
                  disabled
                />
              </div>
            </div>
          </div>
          <div class="col_6">
            <div
              :class="['form_row', { has_error: errorFor('cc_contact_id') }]"
            >
              <label>CC Email</label>
              <Multiselect
                v-model="selectedCcContact"
                :options="contacts"
                :multiple="false"
                :close-on-select="true"
                placeholder="Select a contact"
                label="name"
                :optionHeight="20"
                track-by="id"
                :custom-label="nameWithEmail"
                @Select="onCcContactSelect"
                @remove="onCcContactRemove"
              />
              <v-errors :errors="errorFor('cc_contact_id')"></v-errors>
            </div>
          </div>
        </div>
        <div :class="['form_row', { has_error: errorFor('description') }]">
          <label class="required">Description</label>
          <div class="form_inline">
            <text-editor
              v-model:text="ticket['description']"
              :id="'description'"
            ></text-editor>
            <v-errors :errors="errorFor('description')"></v-errors>
          </div>
        </div>
        <div
          class="custom_tab_content_inner"
          :class="[{ has_error: errorFor('attachments') }]"
        >
          <div class="product_list_wrap">
            <h3>Email attachments</h3>
            <div class="upload_btn dropzone-clickable mt_5 mb_10">
              <button type="button" class="btn btn_black width_150p">
                Upload files
              </button>
            </div>
            <div class="product_list">
              <draggable
                :list="ticket.attachments"
                item-key="image"
                tag="ul"
                ghost-class="ghost"
                @end="imageSorted"
              >
                <template #item="{ element, index }">
                  <li>
                    <div class="inner">
                      <div class="img">
                        <template
                          v-if="
                            ['gif', 'png', 'jpg', 'jpeg', 'JPG'].includes(
                              element.file_extension
                            )
                          "
                        >
                          <div
                            class="cross_ic"
                            @click="removeDragImage(element, index)"
                          >
                            <i class="fas fa-times"></i>
                          </div>
                          <img :src="element.file_path" alt=""/>
                        </template>
                        <template
                          v-if="['pdf'].includes(element.file_extension)"
                        >
                          <div
                            class="cross_ic"
                            @click="removeDragImage(element, index)"
                          >
                            <i class="fas fa-times"></i>
                          </div>
                          <embed :src="element.file_path" />
                        </template>
                        <template
                          v-if="
                            [
                              'xls',
                              'xlsx',
                              'xlm',
                              'xla',
                              'xlc',
                              'xlt',
                              'xlw',
                              'csv',
                            ].includes(element.file_extension)
                          "
                        >
                          <div
                            class="cross_ic"
                            @click="removeDragImage(element, index)"
                          >
                            <i class="fas fa-times"></i>
                          </div>
                          <i class="fas fa-file-excel fa-10x"></i>
                        </template>
                        <template
                          v-if="['docx'].includes(element.file_extension)"
                        >
                          <div
                            class="cross_ic"
                            @click="removeDragImage(element, index)"
                          >
                            <i class="fas fa-times"></i>
                          </div>
                          <i class="fas fa-file-word fa-10x"></i>
                        </template>
                        <template
                          v-if="['zip'].includes(element.file_extension)"
                        >
                          <div
                            class="cross_ic"
                            @click="removeDragImage(element, index)"
                          >
                            <i class="fas fa-times"></i>
                          </div>
                          <i class="fas fa-file-archive fa-10x"></i>
                        </template>
                        <!-- <template v-if="allErrors && allErrors['attachments.'+index]">
                            pgh
                            <small v-for="(error, errorIndex) in allErrors['attachments.'+index]" :key="'error_' + index + '_attachments_'+errorIndex">{{error}}</small>
                        </template> -->
                      </div>
                    </div>
                  </li>
                </template>
              </draggable>
            </div>
            <div class="dropzone-previews"></div>
            <div class="dropzone_wrap">
              <div
                class="create_images_drag dropzone-clickable dropzone-container"
              >
                <div class="images">
                  <span>Drag and drop images from your computer.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom_btn">
        <button
          type="button"
          class="btn btn_transparent has_border_radius"
          @click="closeCreateChatTicket"
        >
          Cancel
        </button>
        <button
          type="button"
          class="btn btn_black has_border_radius ml_10 width_100p"
          @click="submitCreateTicket"
          :disabled="isSubmitting"
        >
          Save
        </button>
      </div>
    </div>

    <BaseModal
      v-if="isShowContactModal"
      title="Add Contact"
      :closeModal="closeModal"
      size="modal_850p"
    >
      <AddContactComponent
        :closeModal="closeModal"
        :addNewContract="addNewContract"
        @send-data="receiveCreatedContract"
      />
    </BaseModal>
    <BaseModal
      v-if="isShowCloseTicketModal"
      title="Ticket List"
      :closeModal="openChatTicketCLoseModal"
      size="modal_850p"
    >
      <ChatCloseableTicketList
        :closeModal="openChatTicketCLoseModal"
        :selectedCustomer="currentCustomer.customer"
        :loadData="loadData"
      />
    </BaseModal>
  </div>
</template>

<script>
import { Howl } from 'howler';
// import pusher from "@/util/pusher";
import moment from 'moment';
import { io } from 'socket.io-client';
import { mapGetters } from 'vuex';
// const socket = io();
import TextEditor from '@/components/shared/TextEditor';
import Multiselect from 'vue-multiselect';
import BaseModal from '@/components/BaseModal.vue';
import AddContactComponent from '@/components/shared/contact/AddContractComponent.vue';
import ChatCloseableTicketList from '@/components/shared/ticket/ChatCloseableTicketList.vue';
import draggable from 'vuedraggable';
import Dropzone from 'dropzone';

export default {
  name: 'Chat',
  components: {
    draggable,
    AddContactComponent,
    BaseModal,
    TextEditor,
    Multiselect,
    ChatCloseableTicketList,
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE,
      socketUrl: process.env.VUE_APP_SOCKET_URL,
      appUrl: process.env.VUE_APP_URL,
      isShowContactModal: false,
      isShowCloseTicketModal: false,
      isSubmitting: false,
      queryParams: {
        search_key: '',
      },
      fileType: '',
      incomingMessageSound: null,
      interval: null,
      customers: [],
      chats: [],
      messages: [],
      currentCustomer: null,
      currentCustomerIndex: 0,
      allCustomers: [],
      form: {
        message: '',
        customer_id: null,
        link: '',
        type: 'admin',
      },
      temFile: '',
      tabIsActive: true,
      socket: null,
      isFilterTabActive: 'all',
      statusMapping: {
        closed: 'chat_closed',
        ticket: 'chat_ticket',
        cancel: 'chat_cancel',
      },
      isOpenTicketCreate: false,
      groups: [],
      contacts: [],
      users: [],
      selectedGroup: null,
      selectedUser: null,
      selectedStatus: null,
      selectedPriority: null,
      selectedContact: null,
      selectedCcContact: null,
      companies: [],
      selectedCompany: null,
      statuses: [
        {
          label: 'open',
          name: 'Open',
        },
        {
          label: 'pending',
          name: 'Pending',
        },
        {
          label: 'resolved',
          name: 'Resolved',
        },
        {
          label: 'closed',
          name: 'Closed',
        },
      ],
      priorities: [
        {
          label: 'low',
          name: 'Low',
        },
        {
          label: 'medium',
          name: 'Medium',
        },
        {
          label: 'high',
          name: 'High',
        },
        {
          label: 'urgent',
          name: 'Urgent',
        },
      ],
      ticket: {
        group_id: '',
        user_id: '',
        status: '',
        priority: '',
        company_id: '',
        contact_id: '',
        customer_email: '',
        customer_name: '',
        customer_phone: '',
        cc_contact_id: '',
        cc_email: '',
        subject: '',
        description: '',
        attachments: [],
      },
      filteredChats: [],
    };
  },
  created() {
    this.loadData();
    this.getCompanies();
  },
  watch: {
    tabIsActive: {
      handler: function () {
        this.makeReadMessages();
      },
      deep: true,
    },
    filteredChats: {
      handler: function () {
        let index = this.filteredChats.findIndex(
          (item) => item.id === this.currentCustomer?.id
        );
        if (index !== -1) {
          let lastMessage =
            this.filteredChats[index].messages[
              this.filteredChats[index].messages.length - 1
            ];
          if (lastMessage) {
            this.filteredChats[index].unread_message = 0;
          }
        }
      },
      deep: true,
    },
    currentCustomer: {
      handler(newVal, oldVal) {
        if (newVal.messages !== oldVal?.messages) {
          this.initPusher();
        }
      },
      deep: true, // watches nested changes
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/getUser',
      isMuteNotification: 'settings/isMuteNotification',
    }),
  },
  mounted() {
    this.incomingMessageSound = new Howl({
      src: [`${this.appUrl}/audio.mp3`],
      volume: 1.0,
    });
    // this.initPusher();
    this.interval = setInterval(this.updateTime, 60 * 1000);
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    this.checkTabStatus();
    this.getGroups();
    this.getContacts();
    let that = this;
    const user = JSON.parse(localStorage.getItem('admin')) || null;
    // for image.
    new Dropzone('.dropzone-container', {
      clickable: '.dropzone-clickable',
      disablePreviews: true, // will not show preview
      createImageThumbnails: true,
      addRemoveLinks: true,
      previewsContainer: '.dropzone-previews',
      maxFiles: 2000,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
      url: `${process.env.VUE_APP_API_BASE_URL}/temporary-image-upload`,
      success: function (file, response) {
        let image = {
          id: '',
          sort: that.ticket.attachments.length + 1,
          draft: response.draft,
          file_extension: response.file_extension,
          file_path: response.file_path,
          original_file_name: response.original_file_name,
          original_size: response.original_size,
        };
        that.ticket.attachments.push(image);
        // since no preview there is nothing to remove
        // this.removeFile(file); // This line removes the preview
      },
      error: function (file, response) {
        let errors = that.errors ? that.errors : {};
        errors.attachments =
          errors && errors.attachments ? errors.attachments : [];
        errors.attachments = response.errors.file;
        that.errors = errors;
        // this.removeFile(file);
      },
      removedfile: function () {
        let errors = that.errors ? that.errors : {};
        errors.attachments = null;
        that.errors = errors;
        // since no preview there is nothing to remove
        // file.previewElement.remove();
      },
    });
  },
  beforeUnmount() {
    clearInterval(this.interval);
    document.removeEventListener(
      'visibilitychange',
      this.handleVisibilityChange
    );
    this.closeCreateChatTicket();
  },
  methods: {
    getFileExtension(url){
      return url.split('.').pop().toLowerCase();
    },
    playIncomingMessageSound() {
      if (this.isMuteNotification) {
        this.incomingMessageSound.play();
      }
    },
    handleVisibilityChange() {
      this.checkTabStatus();
    },
    checkTabStatus() {
      this.tabIsActive = !document.hidden;
    },
    updateTime() {
      if (this.currentCustomer && this.currentCustomer.messages.length) {
        const currentTime = moment();
        this.currentCustomer.messages.map((item) => {
          const someDate = moment(item.short_by_date);
          item.created_at = someDate.from(currentTime);
        });
        this.chats.map((customer) => {
          if (customer.lastMessage) {
            const someDate2 = moment(customer.lastMessage.short_by_date);
            customer.lastMessage.created_at = someDate2.from(currentTime);
          }
        });
      }
    },
    initPusher() {
      let self = this;
      self.socket = io(this.socketUrl + '/chat-support');

      // Join as an admin
      self.socket.emit('adminJoin');

      // Listen for messages from customers
      self.socket.on('adminMessage', (data) => {
        if (
          data.data &&
          data.data.event_type &&
          data.data.event_type === 'delete'
        ) {
          self.deleteEventMessage(data.data);
        } else if (
          data.data &&
          data.data.event_type &&
          data.data.event_type === 'read'
        ) {
          self.readStatusChange(data.data);
        } else if (data.type == 'customer') {
          self.rearrangeChatMessage(data.chat_id);
          self.playIncomingMessageSound();
          if (
            parseInt(self.currentCustomer.customer.api_token) ===
            data?.customer?.api_token
          ) {
            self.currentCustomer.messages.push({ ...data });
            let index = self.chats.findIndex(
              (item) => item?.customer?.api_token === data?.customer?.api_token
            );
            if (index !== -1) {
              if (self.chats[index].lastMessage) {
                self.chats[index].lastMessage.created_at = data.created_at;
                self.chats[index].lastMessage.message = data.message;
              }
            }
            setTimeout(() => {
              self.scrollDown();
              self.makeReadMessages();
            }, 200);
          } else {
            let index = self.chats.findIndex(
              (item) => item?.customer.api_token === data?.customer?.api_token
            );
            if (index !== -1) {
              self.chats[index].messages.push({ ...data });
              self.chats[index].unread_message++;
              self.chats[index].last_activity = data.short_by_date;
              if (self.chats[index].lastMessage) {
                self.chats[index].lastMessage.created_at = data.created_at;
                self.chats[index].lastMessage.message = data.message;
              }

              setTimeout(() => {
                self.scrollDown();
                self.sortCustomerList();
              }, 100);
            }
          }
          // if(self.currentCustomer.id == data.chat_id){
          //   self.updateReadingStatus()
          // }
        } else if (data.type == 'admin' && data.event_type === 'delete') {
          self.deleteEventMessage(data);
        } else if (data.type == 'admin') {
          // Push the admin message to the appropriate place
          let index = self.chats.findIndex(
            (item) => item?.customer?.api_token === data?.customer?.api_token
          );
          if (index !== -1) {
            // Update the chat list for the admin
            self.chats[index].messages.push({ ...data });
            self.chats[index].lastMessage.created_at = data.created_at;
            self.chats[index].lastMessage.message = data.message;

            setTimeout(() => {
              self.scrollDown();
            }, 200);
          }
        }
      });

      // Notify admins about new customers
      self.socket.emit('newCustomerJoin');
      self.socket.on('newCustomerJoiningMessage', () => {
        setTimeout(() => {
          this.loadData();
        }, 100);
      });
    },

    selectCurrentCustomer(index) {
      this.currentCustomer = this.filteredChats[index];
      this.updateReadingStatus();

      let findContact = this.contacts.find(
        (item) => item.email === this.currentCustomer?.customer?.email
      );
      this.selectedContact = findContact;
      this.onContactSelect(findContact);

      setTimeout(() => {
        this.sortCurrentCustomerMessages();
        this.updateTime();
        this.scrollDown();
      }, 100);
    },
    rearrangeChatMessage(chat_id) {
      const target = this.filteredChats.filter((item) => item.id === chat_id);
      const others = this.filteredChats.filter((item) => item.id !== chat_id);
      this.filteredChats = [...target, ...others];
    },
    loadData(isSetCurrent = false) {
      this.axios
        .get('/chats-customers', {
          params: { ...this.queryParams },
        })
        .then((response) => {
          this.customers = response.data.customers;
          this.chats = response.data.data;
          this.filteredChats = response.data.data;
          this.allCustomers = response.data.data;
          // this.messages = response.data;
          this.sortCustomerList();
          if (!isSetCurrent) {
            this.currentCustomer = this.chats.length
              ? this.chats[this.currentCustomerIndex]
              : null; //Fist open first customers messages
          } else {
            this.currentCustomer = this.chats.find(
              (chat) => chat.id === this.currentCustomer.id
            );
          }
          this.sortCurrentCustomerMessages();
        });
    },
    sortCustomerList() {
      this.chats.sort((a, b) => {
        return new Date(b.created_at) - new Date(a.created_at);
      });
    },
    sortCurrentCustomerMessages() {
      if (this.currentCustomer && this.currentCustomer.messages.length) {
        this.currentCustomer.messages.sort((a, b) => {
          return new Date(a.short_by_date) - new Date(b.short_by_date);
        });
      }
    },
    makeReadMessages() {
      if (this.currentCustomer && this.tabIsActive) {
        this.axios
          .get(
            '/chat/message-unread?customer_id=' +
              this.currentCustomer.customer.id +
              '&type=customer'
          )
          .then((response) => {
            this.socket.emit('adminMessage', response.data);
          });
      }
    },
    removeMessage(i, message) {
      this.axios
        .get('/chat/delete-message?id=' + message.id + '&type=admin')
        .then((response) => {
          this.socket.emit('adminMessage', response.data);
          this.currentCustomer.messages.splice(i, 1);
        });
    },
    deleteEventMessage(event) {
      if (
        parseInt(this.currentCustomer.customer.id) ===
        parseInt(event.customer_id)
      ) {
        let index = this.currentCustomer.messages.findIndex(
          (item) => item.id === parseInt(event.id)
        );
        if (index != -1) {
          this.currentCustomer.messages.splice(index, 1);
        }
      } else {
        let index = this.customers.findIndex(
          (item) => item.id === parseInt(event.customer_id)
        );
        if (index != -1) {
          let msgIndex = this.customers[index].messages.findIndex(
            (item) => item.id === parseInt(event.id)
          );
          if (msgIndex != -1) {
            this.customers[index].messages.splice(msgIndex, 1);
          }
        }
      }
    },
    scrollDown() {
      if (this.currentCustomer.messages.length) {
        const div = document.getElementById('scrollableDiv');
        if (div) {
          div.scrollTo({
            top: div.scrollHeight,
            behavior: 'smooth',
          });
        }
      }
    },
    filterChatStatusTab(status) {
      if (status === 'all') {
        this.filteredChats = [...this.chats];
      } else if (status === 'is_ticket') {
        this.filteredChats = this.chats.filter((item) => item.is_ticket === 1);
      } else {
        this.filteredChats = this.chats.filter(
          (item) => item.status === status
        );
      }
    },

    filterItems() {
      let filteredCustomers = [...this.filteredChats];

      if (this.queryParams.search_key) {
        const keyword = this.queryParams.search_key.trim().toLowerCase();

        filteredCustomers = filteredCustomers.filter(
          (item) =>
            item?.customer?.name?.toLowerCase()?.includes(keyword) ||
            item?.customer?.email?.toLowerCase()?.includes(keyword)
        );
      } else {
        const status = this.isFilterTabActive || 'all';
        if (status === 'all') {
          filteredCustomers = [...this.chats];
        } else if (status === 'ticket') {
          filteredCustomers = this.chats.filter((item) => item.is_ticket === 1);
        } else {
          filteredCustomers = this.chats.filter(
            (item) => item.status === status
          );
        }
      }

      this.filteredChats = filteredCustomers;
    },

    clearSearch() {
      this.queryParams.search_key = '';

      if (this.isFilterTabActive === 'all') {
        this.filteredChats = [...this.chats];
      } else if (this.isFilterTabActive === 'ticket') {
        this.filteredChats = this.chats.filter((item) => item.is_ticket === 1);
      } else {
        this.filteredChats = this.chats.filter(
          (item) => item.status === 'closed'
        );
      }
    },
    readStatusChange(event) {
      if (
        parseInt(this.currentCustomer.customer.id) ===
        parseInt(event.customer_id)
      ) {
        this.currentCustomer.messages.map((item) => (item.read = 1));
      } else {
        let index = this.chats.findIndex(
          (item) => item.id === parseInt(event.customer_id)
        );
        if (index != -1) {
          this.chats[index].messages.map((item) => (item.read = 1));
        }
      }
    },
    updateReadingStatus() {
      this.axios
        .post('/chat/change-message-status', {
          customer_id: this.currentCustomer?.customer?.id,
          type: 'customer',
        })
        .then((response) => {
          this.socket.emit('adminMessage', response.data);
        });
    },
    sendMessage() {
      if (this.form.message || this.form.link) {
        this.form.customer_id = this.currentCustomer.customer.id;

        let formData = new FormData();

        window.$.each(this.form, function (key, file) {
          formData.append(key, file);
        });
        this.removeImage();
        this.form.message = '';
        this.axios
          .post('/chat/send-message', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then(({ data }) => {
            let index = this.currentCustomer.messages.push({
              id: '',
              type: 'admin',
              created_at: 'Just Now',
              read: 0,
              message: data.data.message,
            });
            setTimeout(() => {
              this.scrollDown();
            }, 20);

            this.currentCustomer.messages[index - 1].id = data.data.id;
            this.currentCustomer.messages[index - 1].created_at = data.data.created_at;
            this.currentCustomer.messages[index - 1].link = data.data.link;
            this.currentCustomer.messages[index - 1].admin = data.data.admin;
            // this.currentCustomer.messages[index-1].user = data.data.user
            this.updateTime();
            this.socket.emit('adminMessage', data.data);

            setTimeout(() => {
              this.scrollDown();
              this.removeImage();
            }, 20);
          })
            .catch((err) => {
              this.showFailMsg(err?.response.data?.errors?.link[0]);
              console.log(err.response.data, 'eeeeee')
            });
      }
    },
    removeImage() {
      this.temFile = '';
      this.form.link = '';
      this.$refs.fileInput.value = '';
    },
    openFileModal() {
      this.$refs.fileInput.click();
    },
    onFileChange(event) {
      let files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;
      let file = event.target.files[0];
      this.form.link = file;
      this.fileType = file.type
      this.temFile = URL.createObjectURL(file);
    },
    handlePaste(event) {
      const items = event.clipboardData.items;
      for (let item of items) {
        if (item.type.startsWith('image/')) {
          const file = item.getAsFile();

          if (file) {
            this.form.link = file; // Assign the file directly
            this.temFile = URL.createObjectURL(file); // Create a preview URL
          }
        }
      }
    },
    openCreateChatTicket() {
      let findContact = this.contacts.find(
        (item) => item.email === this.currentCustomer?.customer?.email
      );
      this.selectedContact = findContact;
      this.onContactSelect(findContact);
      document.body.classList.add('right_menu_open');
    },
    openModal() {
      this.isShowContactModal = true;
    },
    closeModal() {
      this.isShowContactModal = false;
    },
    closeCreateChatTicket() {
      document.body.classList.remove('right_menu_open');
    },
    nameWithEmail(data) {
      return `${data.name} — [ ${data.email} ]`;
    },
    getGroups() {
      this.axios.get('/active-groups-for-relation').then(({ data }) => {
        this.groups = data.data;
      });
    },
    receiveCreatedContract(contract) {
      if (contract && contract.id) {
        this.ticket.contact_id = contract.id;
        this.getContacts();
        this.selectedContact = contract;
        this.onContactSelect(contract);
      }
    },
    addNewContract() {
      this.axios.post('').then(() => {});
    },
    getContacts() {
      this.axios.get('/active-contacts-for-relation').then(({ data }) => {
        this.contacts = data.data;
      });
    },
    onGroupSelect(selected) {
      this.ticket.group_id = selected.id;
      this.users = selected.users;
      this.selectedUser = null;
      this.ticket.user_id = '';
    },
    onGroupRemove() {
      this.selectedGroup = null;
      this.ticket.group_id = '';
      this.selectedUser = null;
      this.ticket.user_id = '';
    },
    onStatusSelect(selected) {
      this.ticket.status = selected.label;
    },
    onStatusRemove() {
      this.ticket.status = '';
    },
    onPrioritySelect(selected) {
      this.ticket.priority = selected.label;
    },
    onPriorityRemove() {
      this.ticket.priority = '';
    },
    onUserSelect(selected) {
      this.ticket.user_id = selected.id;
    },
    onUserRemove() {
      this.selectedUser = null;
      this.ticket.user_id = '';
    },
    onContactSelect(selected) {
      this.ticket.contact_id = selected?.id;
      this.ticket.company_id = selected?.company_id;
      this.ticket.customer_email = selected?.email;
      this.ticket.customer_name = selected?.name;
      this.ticket.customer_phone = selected?.phone;
      this.resetSelectedCompany();
    },
    onContactRemove() {
      this.selectedContact = null;
      this.ticket.contact_id = '';
      this.ticket.company_id = '';
      this.ticket.customer_email = '';
      this.ticket.customer_name = '';
      this.ticket.customer_phone = '';
      this.resetSelectedCompany();
    },
    submitCreateTicket() {
      this.isSubmitting = true;
      this.allErrors = null;
      let formData = new FormData();
      Object.keys(this.ticket).forEach((key) => {
        formData.append(key, this.ticket[key] ? this.ticket[key] : '');
      });
      formData.append('user', JSON.stringify(this.user));
      formData.append('attachments', JSON.stringify(this.ticket.attachments));

      if (this.selectedCompany?.id) {
        formData.append('new_company_id', this.selectedCompany?.id);
      }

      formData.append('customer_id', this.currentCustomer.customer.id);
      formData.append('chat_id', this.currentCustomer.id);
      formData.delete('user_id');
      formData.append(
        'user_id',
        this.selectedUser?.map((user) => user.id) ?? ''
      );

      this.axios
        .post('/store-chat-support-ticket', formData)
        .then(() => {
          this.closeCreateChatTicket();
          this.resetForm();
          this.loadData('no');
          this.showSuccessMsg('Ticket Created Successfully!');
        })
        .catch((err) => {
          this.allErrors = err.response.data.errors;
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
    removeDragImage(element, index) {
      if (!this.ticket) return;
      if (!this.ticket.attachments) return;
      if (!element.id) {
        let formData = new FormData();
        formData.append('draft', element.draft);
        this.axios.post('/temporary-image-remove', formData).then(() => {});
      }
      this.ticket.attachments.splice(index, 1);
      this.imageSorted();
    },
    imageSorted() {
      let sort = 1;
      for (let index = 0; index < this.ticket.attachments.length; index++) {
        this.ticket.attachments[index].sort = sort++;
      }
    },
    resetForm() {
      this.selectedStatus = null;
      this.selectedPriority = null;
      this.selectedContact = null;
      this.onGroupRemove();
      this.onUserRemove();
      /*this.ticket = {
        subject: '',
        description: '',
      }*/
    },
    openChatTicketCLoseModal() {
      this.isShowCloseTicketModal = false;
    },
    getCompanies() {
      this.axios.get('/active-companies-for-relation').then(({ data }) => {
        this.companies = data.data;
      });
    },
    resetSelectedCompany() {
      this.selectedCompany = null;
    },
    onCcContactSelect(selected) {
      this.ticket.cc_contact_id = selected.id;
      this.ticket.cc_email = selected.email;
    },
    onCcContactRemove() {
      this.ticket.cc_contact_id = '';
      this.ticket.cc_email = '';
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<style scoped lang="scss">
.search_box span {
  position: absolute;
  top: 34%;
  right: 5px;
  font-size: 16px;
  cursor: pointer;
}
.attached_image {
  position: absolute;
  bottom: 30px;
}
.attached_image span {
  position: absolute;
  right: 0;
  z-index: 999;
  background: transparent;
  padding: 2px;
  height: 16px;
  cursor: pointer;
}
.attached_image span i {
  color: #fff;
}
.color_green {
  color: green;
}
.chat_close_message {
  font-size: 20px;
  text-align: center;
  padding: 5px 0;
  color: #312e81;
}
.selected_customer {
  background: #312e81 !important;
  color: #ffffff !important;
}
.create_images_drag {
  position: relative;
  width: 100%;
  background: #efefef;
  min-height: 212px;
  margin-bottom: 10px;
}

.create_images_drag span {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  font-size: 18px;
  color: #999;
}
.inner {
  border: 1px solid #e2e2e2 !important;
}
.product_list_wrap {
  .upload_btn {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    span {
      margin-left: 20px;
    }
  }
  .product_list {
    ul {
      display: flex;
      flex-wrap: wrap;
      margin-left: -5px;
      margin-right: -5px;
      li {
        width: 20%;
        padding-left: 5px;
        padding-right: 5px;
        padding-bottom: 10px;
        .inner {
          .img {
            position: relative;
            overflow: hidden;
            transition: all 0.3s;
            img {
              width: 100%;
            }
            .cross_ic {
              position: absolute;
              top: 20px;
              right: 3px;
              z-index: 2;
              background: red;
              border-radius: 50%;
              width: 20px;
              height: 20px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 15px;
              opacity: 0;
            }
            &:hover {
              transition: all 0.3s;
              .cross_ic {
                opacity: 1;
                top: 3px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
